import { useEffect, useState } from 'react';

import { isNil } from 'ramda';
import type { GroupBase } from 'react-select-5';

import { Controls, Props } from './types';

export function useMenuLocker<
  _Option = unknown,
  _IsMulti extends boolean = boolean,
  _Group extends GroupBase<_Option> = GroupBase<_Option>,
>(controls: Controls<_Option, _IsMulti, _Group>, props: Props<_Option, _IsMulti, _Group>) {
  const { menuOpen, selectRef } = controls;
  const { lockMenu, menuIsOpen } = props;

  const [reactSelectsOwnMenuState, syncReactSelectsOwnMenuState] = useState(false);
  const [openMenuOnFocus, setOpenMenuOnFocus] = useState<true | undefined>(undefined);

  useEffect(() => {
    if (!isNil(menuIsOpen)) return;

    if (lockMenu && isNil(menuOpen.value)) {
      menuOpen.setValue(reactSelectsOwnMenuState);
    }

    // HACK
    // When menuIsOpen turns to undefined and the user has clicked outside of the select (e.g. closed a preview modal),
    // react-select will close the menu. Just focusing back on react-select doesn't help because openMenuOnFocus by default is false.
    // We need to set openMenuOnFocus to true for a brief moment to be able to focus on the select and open the menu.
    if (!lockMenu && !isNil(menuOpen.value)) {
      if (menuOpen.value) setOpenMenuOnFocus(true);
      setTimeout(() => {
        if (menuOpen.value) selectRef.current?.focus();
        menuOpen.setValue(undefined);
        if (menuOpen.value) setOpenMenuOnFocus(undefined);
      });
    }
  }, [lockMenu]);

  return {
    onMenuOpen: () => syncReactSelectsOwnMenuState(true),
    onMenuClose: () => syncReactSelectsOwnMenuState(false),
    openMenuOnFocus,
  };
}
